import React, {Component} from 'react';
import {apiService} from '../../common/apiCallService';
import {baseUrl} from '../../common/config.js';
import Loading from '../Loading.js';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ReactTooltip from 'react-tooltip'

var fileDownload = require('react-file-download')

export default class DownloadRawhands extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }

  }

  handHistoryForPlayer = () => {
    if(this.props.totalGame > 10000) {
      alert("Number of hands should be less than 10K to download Raw Hands. Please reduce the date range and try again")
      return
    }
    this.setState({loading: true})
    apiService(baseUrl + '/pokerWatch/rawHandPlayerHist', {
      "fromDate": this.props.fromDate,
      "toDate": this.props.toDate,
      "fromTime":this.props.fromTime,
      "toTime":this.props.toTime,
      "shift":this.props.shift,
      "accountName": this.props.accountName,
      "gameType":'cash'
    }, (data) => {
      if (data) {
        this.setState({loading: false})
        var palyerHand = new Array()
        var fromDate = moment(this.props.fromDate).format("YYYY-MM-DD").replace(/\-/g, "")
        var toDate = moment(this.props.toDate).format("YYYY-MM-DD").replace(/\-/g, "")
        var PlayerHandHistory = (fromDate + "-" + toDate + "_" + this.props.players_alias + ".txt")
        for (var i = 0; i < data.list.length; i++) {
          palyerHand.push(data.list[i].handHistory.replace(/\#\*\#/g, "\r\n") + "\r\n\r\n");
        }
        fileDownload(palyerHand.join(""), PlayerHandHistory)
      } else {
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.location.pathname)
          this.setState({loginRedirect: true})
        }
        this.setState({loading: false})
        alert("No Data Available")
      }
    }, (data) => {
      this.setState({loading: false})
    })
  }

  render() {
    let downBtn = null
    if(this.props.showType == 'button') {
      downBtn = <RaisedButton primary={true} onClick={this.handHistoryForPlayer}>
                      <i className="fa fa-download" style={{color: "white",fontSize: "1.5em"}} aria-hidden="true"></i>
                      <b style={{color: "white",padding: "5px"}}></b>
                    </RaisedButton>
    } else {
      downBtn = <IconButton iconClassName="fa fa-download" data-tip="Download Hands" iconStyle={{color: this.props.totalGame > 10000 ? "grey" : "rgb(222, 70, 15)"}} onTouchTap={this.handHistoryForPlayer}/>
    }
    return (
      <div>
      <ReactTooltip />
      {this.state.loading
        ? <Loading/>
        : null}
        {downBtn}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchComp/DownloadRawhands.js
 **/